import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

export default function ModalPortal({ children }: PropsWithChildren<unknown>) {
  return createPortal(children, document.fullscreenElement ?? document.body);
}
